/* formatowanie terminu kursu */

import { useState } from "react";
import { ACTIVITY_CHOICES } from "../bb/BBEnum";
import { NoOrphans } from "../../components/elements/NoOrphans";
// import { IBBActivity } from "../../interfaces/IBB";
import BBHelperClass, { ActivityMatrix } from "../../classes/BBHelperClass";
import { IProduct } from "../../interfaces/IProducts";

export interface IBBActivityComp {
    activityType: ACTIVITY_CHOICES;
    hideImage?: boolean;
    hideTabs?: boolean;
    // hr?: boolean; // czy rysować linię po wyświetleniu teminu
    // breakLine?: boolean; // czy łamać linię po wyświetleniu teminu
    // showIcon?: boolean; // czy wyświetlać ikonę
    // showLabel?: boolean; // pokażnapis "termin:"
    // size?: componentSize;
}
export interface IActivityDesc {
    detail: string;
    how2do: JSX.Element;
    how2start: JSX.Element;
    pakiet: JSX.Element;
}

/* -------------------------------------------------
 *
 * ------------------------------------------------- */
function how2doDesc(activityType: ACTIVITY_CHOICES) {
    if (activityType === ACTIVITY_CHOICES.ACTIVITY_IRON) {
        return (
            <ul>
                <li>
                    Aby zdobyć tytuł Iron Teachera wykonaj w październiku wszystkie trzy aktywności:{" "}
                    <b>
                        {ActivityMatrix[ACTIVITY_CHOICES.ACTIVITY_WALK].form1} min. {ActivityMatrix[ACTIVITY_CHOICES.ACTIVITY_IRON].distanceWalk} km,{" "}
                        {ActivityMatrix[ACTIVITY_CHOICES.ACTIVITY_RUN].form1} min. {ActivityMatrix[ACTIVITY_CHOICES.ACTIVITY_IRON].distanceRun} km,{" "}
                        {ActivityMatrix[ACTIVITY_CHOICES.ACTIVITY_RIDE].form1} min. {ActivityMatrix[ACTIVITY_CHOICES.ACTIVITY_IRON].distanceRide} km,
                    </b>{" "}
                    i zarejestruj swoją aktywność w dowolnej aplikacji.
                    <br />
                    <small>
                        Dystans pokonaj w wybranym przez siebie miejscu – jednorazowo lub podziel na mniejsze odległości.{" "}
                        <b>Pamiętaj również, że możesz pokonać większe niż wymagane liczby kiometrów i zarejestrować wiele aktywności.</b>
                    </small>
                </li>
                <li>
                    Jeśli planujesz zrealizować większy dystans (jednorazowo lub podczas kilku {ActivityMatrix[activityType].form3} w miesiącu) i
                    chcesz, żeby Twój wynik pojawił się w&nbsp; ogólnopolskim rankingu Biegu Belfrów:
                    <br />
                    <small>
                        <ul>
                            <li>Wyraź zgodę na publikację swojego nicku w tabeli rankingowej.</li>
                            <li>Po każdej aktywności wpisz liczbę kilometrów, którą pokonałaś/eś. Lista jest aktualizowana na bieżąco.</li>
                            <li>Po zrealizowaniu aktywności prześlij zrzuty ekranu na bieg@odnrewers.pl</li>
                        </ul>
                    </small>
                </li>
            </ul>
        );
    }
    return (
        <>
            <ul>
                <li>
                    Aby zasłużyć na medal Biegu Belfrów {ActivityMatrix[activityType].form1} w październiku{" "}
                    <b>minimum {ActivityMatrix[activityType].distance} km</b> i zarejestruj swoją aktywność w dowolnej aplikacji.
                    <br />
                    <small>
                        Dystans pokonaj w wybranym przez siebie miejscu – jednorazowo lub podziel na mniejsze odległości.{" "}
                        <b>
                            Pamiętaj również, że możesz {ActivityMatrix[activityType].form2} więcej niż {ActivityMatrix[activityType].distance} km i
                            zarejestrować wiele aktywności.
                        </b>
                    </small>
                </li>
                <li>
                    Jeśli planujesz zrealizować większy dystans (jednorazowo lub podczas kilku {ActivityMatrix[activityType].form3} w miesiącu) i
                    chcesz, żeby Twój wynik pojawił się w&nbsp; ogólnopolskim rankingu Biegu Belfrów:
                    <br />
                    <small>
                        <ul>
                            <li>Wyraź zgodę na publikację swojego nicku w tabeli rankingowej.</li>
                            <li>Po każdej aktywności wpisz liczbę kilometrów, którą pokonałaś/eś. Lista jest aktualizowana na bieżąco.</li>
                            <li>
                                Pamiętaj o każdorazowym rejestrowaniu swojej aktywności w dowolnej aplikacji. Możemy prosić Cię o udokumentowanie
                                pokonanego dystansu w postaci np. zrzuty ekranu z programu.
                            </li>
                        </ul>
                    </small>
                </li>
            </ul>
        </>
    );
}

/* -------------------------------------------------
 *
 * ------------------------------------------------- */
function how2startDesc(activityType: ACTIVITY_CHOICES) {
    return (
        <>
            <ul>
                <li>
                    <a href="">Zaloguj się</a> i zapisz na Bieg Belfrów.
                    <br />
                    <small>Możesz zapisać się indywidualnie, utworzyć grupę lub dołączyć do już istniejącej.</small>
                </li>
                <li>
                    Wybierz pakiet <b>{ActivityMatrix[activityType].packageName.toUpperCase()}</b> i - opcjonalnie - koszulkę <br />
                    <small>Możesz wybrać więcej kategorii.</small>
                </li>
                <li>Ureguluj opłatę startową.</li>
                <li>
                    Po zaksięgowaniu płatności, na wskazany adres, wyślemy <a href=""> pakiet startowy</a>
                    {activityType === ACTIVITY_CHOICES.ACTIVITY_IRON && (
                        <>, a po udokumentowaniu przez Ciebie zrealizowanych dystansów – statuetkę Iron Teachera</>
                    )}
                    .
                </li>
            </ul>
        </>
    );
}

/* -------------------------------------------------
 *
 * ------------------------------------------------- */
function pakietDesc(activityType: ACTIVITY_CHOICES) {
    return (
        <>
            Pakiet startowy kosztuje {ActivityMatrix[activityType].price} zł (+koszt wysyłki) i&nbsp;zawiera:
            <ul>
                <li>medal</li>
                {activityType === ACTIVITY_CHOICES.ACTIVITY_IRON && <li>statuetka Iron Teachera</li>}
                <li>pamiątkowy gadżet</li>
                <li>numer startowy do pobrania w PDF</li>
            </ul>
            <small>Opcjonalnie, podczas zapisu, możesz dokupić koszulkę Biegu Belfrów.</small>
        </>
    );
}

/* -------------------------------------------------
 *
 * ------------------------------------------------- */
export const ActivityDesc: { [key in ACTIVITY_CHOICES]: IActivityDesc } = {
    0: {
        detail: "- ? -",
        pakiet: <></>,
        how2do: <></>,
        how2start: <></>,
    },
    /* ACTIVITY_WALK = 1, */
    1: {
        detail: "Ubierz wygodne buty, włącz aplikację i wybierz się na minimum 6&nbsp;km spacer – samodzielnie lub z innymi Belferkami i Belframi. Tu nie liczy się tempo, ale pomaganie, zdrowie i endorfiny!",
        pakiet: pakietDesc(ACTIVITY_CHOICES.ACTIVITY_WALK),
        how2do: how2doDesc(ACTIVITY_CHOICES.ACTIVITY_WALK),
        how2start: how2startDesc(ACTIVITY_CHOICES.ACTIVITY_WALK),
    },
    /*ACTIVITY_RUN = 2, */
    2: {
        detail: "Koniecznie zrób rozgrzewkę i przebiegnij minimum 6&nbsp;km. Możesz pokusić się o pobicie rekordu życiowego lub po prostu zaplanować spokojny trucht. ",
        pakiet: pakietDesc(ACTIVITY_CHOICES.ACTIVITY_RUN),
        how2start: how2startDesc(ACTIVITY_CHOICES.ACTIVITY_RUN),
        how2do: how2doDesc(ACTIVITY_CHOICES.ACTIVITY_RUN),
    },
    /* ACTIVITY_RIDE = 3, */
    3: {
        detail: "Przygotuj rower, włóż kask i ruszaj przed siebie. Gdy licznik pokaże 12&nbsp;km, możesz skończyć przejażdżkę lub dać się ponieść rowerowej przygodzie!",
        pakiet: pakietDesc(ACTIVITY_CHOICES.ACTIVITY_RIDE),
        how2start: how2startDesc(ACTIVITY_CHOICES.ACTIVITY_RIDE),
        how2do: how2doDesc(ACTIVITY_CHOICES.ACTIVITY_RIDE),
    },
    /*ACTIVITY_IRON = 4,*/
    4: {
        detail: "To zadanie nie tylko dla matematyków: dodaj do siebie wszystkie dyscypliny i pomnóż kilometry! Zrealizuj wyzwanie, a otrzymasz specjalną statuetkę Iron Teachera!",
        pakiet: pakietDesc(ACTIVITY_CHOICES.ACTIVITY_IRON),
        how2start: how2startDesc(ACTIVITY_CHOICES.ACTIVITY_IRON),
        how2do: how2doDesc(ACTIVITY_CHOICES.ACTIVITY_IRON),
    },
};

// const IconDown = () => {
//     return (
//         <span className="icon">
//             <i className="fas fa-angle-down" aria-hidden="true"></i>
//         </span>
//     );
// };

// const IconUp = () => {
//     return (
//         <span className="icon">
//             <i className="fas fa-angle-up" aria-hidden="true"></i>
//         </span>
//     );
// };

type infoBox = "none" | "how2start" | "pakiet" | "how2do";

/* -------------------------------------------------
 * baner w sklepie
 * bbActivities -> charakterystyka aktywności odczytana z API, jezeli undefined to zastosuj jakieś wartości domyślne
 * ------------------------------------------------- */
export const BBActivityShop = (props: { activityType: ACTIVITY_CHOICES; bbActivity?: IProduct }) => {
    if (props.bbActivity == undefined || props.bbActivity.inStore == undefined || props.bbActivity.inStore.length == 0) {
        return <></>;
    }

    let productObj = props.bbActivity.inStore[0];

    return (
        <>
            <div className="media">
                <div className="media-left">
                    <figure className="image is-48x48">
                        <img src={ActivityMatrix[props.activityType].icon.toString()} alt={ActivityMatrix[props.activityType].title} />
                    </figure>
                </div>
                <div className="media-content">
                    <p className="title is-4">{productObj.vName}</p>
                    <p className="subtitle is-6">
                        minimum {ActivityMatrix[props.activityType].distance}
                        {ActivityMatrix[props.activityType].distanceWalk}
                        {ActivityMatrix[props.activityType].distanceWalk && " + "}
                        {ActivityMatrix[props.activityType].distanceRun}
                        {ActivityMatrix[props.activityType].distanceRun && " + "}
                        {ActivityMatrix[props.activityType].distanceRide}
                        &nbsp;km
                        <p>
                            <strong>{productObj.price} </strong>
                            <small>zł</small>
                        </p>
                        {/* <p>
                            <a href="">więcej informacji</a>
                        </p> */}
                    </p>
                </div>
            </div>
        </>
    );
};
/* -------------------------------------------------
 * mały baner aktywności
 * ------------------------------------------------- */
export const BBActivityBanner = (props: { activityType: ACTIVITY_CHOICES }) => {
    return (
        <>
            <div className="media">
                <div className="media-left">
                    <figure className="image is-48x48">
                        <img src={ActivityMatrix[props.activityType].icon.toString()} alt={ActivityMatrix[props.activityType].title} />
                    </figure>
                </div>
                <div className="media-content">
                    <p className="title is-4">{ActivityMatrix[props.activityType].title}</p>
                    <p className="subtitle is-6">
                        minimum {ActivityMatrix[props.activityType].distance}
                        {ActivityMatrix[props.activityType].distanceWalk}
                        {ActivityMatrix[props.activityType].distanceWalk && " + "}
                        {ActivityMatrix[props.activityType].distanceRun}
                        {ActivityMatrix[props.activityType].distanceRun && " + "}
                        {ActivityMatrix[props.activityType].distanceRide}
                        &nbsp;km
                    </p>
                </div>
            </div>
        </>
    );
};
/* -------------------------------------------------
 * baner na stronie
 * ------------------------------------------------- */
const BBActivityComp = (props: IBBActivityComp) => {
    const [showMore, setShowMore] = useState("none" as infoBox);
    return (
        <>
            <div className="card">
                {!(props.hideImage === true) && (
                    <div className="card-image">
                        <figure className="image">
                            <img src={ActivityMatrix[props.activityType].img.toString()} alt={ActivityMatrix[props.activityType].title} />
                        </figure>
                    </div>
                )}
                <div className="card-content">
                    <BBActivityBanner activityType={props.activityType} />

                    {/* <div className="content"> */}
                    <NoOrphans className="content">{ActivityDesc[props.activityType].detail}</NoOrphans>

                    {/* {showMore === "how2" && <div className="pt-3"> {ActivityDesc[props.activityType].how2} </div>}
                        {showMore === "pakiet" && <div className="pt-3"> {ActivityDesc[props.activityType].pakiet} </div>} */}
                    {/* </div> */}
                    {!(props.hideTabs === true) && (
                        <footer className="card-footer">
                            <button
                                className={"card-footer-item button is-ghost " + (showMore === "how2start" && " is-underlined")}
                                onClick={() => setShowMore(showMore === "how2start" ? "none" : "how2start")}
                            >
                                Jak zacząć
                            </button>

                            <button
                                className={"card-footer-item button is-ghost " + (showMore === "how2do" && " is-underlined")}
                                onClick={() => setShowMore(showMore === "how2do" ? "none" : "how2do")}
                            >
                                Realizacja
                            </button>

                            <button
                                className={"card-footer-item button is-ghost " + (showMore === "pakiet" && " is-underlined")}
                                onClick={() => setShowMore(showMore === "pakiet" ? "none" : "pakiet")}
                            >
                                Pakiet startowy
                            </button>
                        </footer>
                    )}
                    <div className="content">
                        {showMore === "how2start" && <div className="pt-3"> {ActivityDesc[props.activityType].how2start} </div>}
                        {showMore === "how2do" && <div className="pt-3"> {ActivityDesc[props.activityType].how2do} </div>}
                        {showMore === "pakiet" && <div className="pt-3"> {ActivityDesc[props.activityType].pakiet} </div>}
                        {showMore !== "none" && (
                            <div className="pt-4">
                                <input className="button" type="submit" value="Zapisz się teraz" />
                            </div>
                        )}
                    </div>
                    {/* <footer className="card-footer" onClick={() => setShowMore(!showMore)}>
                        <p className="card-header-title">{!showMore ? "Pokaż więcej" : "Pokaż mniej"}</p>
                        <button className="card-header-icon" aria-label="more options">
                            {!showMore ? <IconDown /> : <IconUp />}
                        </button>
                    </footer> */}
                </div>
            </div>
        </>
    );
};

export default BBActivityComp;
